import { Dimensions, Image, Linking, Pressable, StyleSheet, TouchableOpacity, View } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import Svg, { G, Path } from "react-native-svg";
import { hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";

import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import ImageView from "../../../src/image";

import { Images } from "assets";
import VText from "components/VText";
import { fp } from "utils/normalizeV2";
import { logEvent } from "firebase/analytics";
import { analytics } from "utils/firebaseConfig";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { useGlobalSearchParams } from "expo-router";
import Paragraph from "components/Pharagraph";
import Heading from "components/Heading";
import { Link } from "expo-router";

const SocialSection = (data) => {
    const [currentActiveIndex, setCurrentActiveIndex] = useState(0);

    const _slider1Ref = useRef();

    const instaPosts = useSelector((state) => state.HomeReducer.instaPosts) || [];

    const dispatch = useDispatch();
    const local = useGlobalSearchParams();
    const gender = local?.gender || "female";

    return (
        <View style={styles.container}>
            <Heading type="h2" style={styles.headingText}>Explore @vetirapp</Heading>
            <Carousel
                loop
                height={wp(400)}
                width={wp(400)}
                vertical={false}
                style={{
                    width: Dimensions.get("window").width,
                    marginVertical: spV(28),
                }}
                ref={_slider1Ref}
                scrollEnabled={true}
                data={Array.isArray(instaPosts) ? [...instaPosts, ...instaPosts] : []}
                scrollAnimationDuration={1000}
                renderItem={({ item, index }) => {
                    return (
                        <Link
                            key={index}
                            activeOpacity={1}
                            href={item?.postUrl}
                            onPress={() => {
                                const eventData = {
                                    current_section: gender === "female" ? "Women" : "Men",
                                    post_id: item?._id,
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.INSTAGRAM_POST_CLICKED, eventData);
                                // Linking.openURL(item?.postUrl);
                            }}
                            style={[styles.instaCard]}
                        >
                            <ImageView
                                accessibilityLabel={item?.postCaption}
                                resizeMode={ImageView.resizeMode.cover}
                                source={{
                                    priority: ImageView.priority.high,
                                    uri: item?.postImage,
                                }}
                                style={{
                                    width: wp(400),
                                    height: wp(400),
                                }}
                            />
                            <Svg
                                version="1.1"
                                id={`layer-social-${index}`}
                                x="0px"
                                y="0px"
                                viewBox="0 0 122.14 122.88"
                                width="24"
                                height="24"
                                fill="white"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                    position: "absolute",
                                    height: 30,
                                    width: 30,
                                    right: 20,
                                    top: 20,
                                }}
                            >
                                <G>
                                    <Path d="M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" />
                                </G>
                            </Svg>
                        </Link>
                    );
                }}
                onSnapToItem={(index) => setCurrentActiveIndex(index)}
            />
            {/* {currentIndex > 0 && ( */}
            <TouchableOpacity
                style={[styles.navButton, styles.navButtonLeft]}
                onPress={() => {
                    _slider1Ref?.current?.prev({
                        animated: true,
                        count: 1,
                    });
                }}
            >
                <Image accessibilityLabel="Left Arrow" style={styles.navButtonImage} source={Images.left} />
            </TouchableOpacity>
            {/* )} */}
            {/* {currentIndex + 2 < instaPosts.length - 3 && ( */}
            <TouchableOpacity
                style={[styles.navButton, styles.navButtonRight]}
                onPress={() => {
                    _slider1Ref?.current?.next({
                        animated: true,
                        count: 1,
                    });
                }}
            >
                <Image accessibilityLabel="Right Arrow" style={styles.navButtonImage} source={Images.right} />
            </TouchableOpacity>
            {/* )} */}
            <View style={{width:wp(240),alignSelf:'center'}}>
            <Link  style={{width:wp(240)}}
            onPress={() => {
                logEvent(analytics, FIREBASE_EVENT_NAMES.INSTAGRAM_CLICKED, {
                    [FIREBASE_EVENT_PARAMS.OPEN_INSTAGRAM_FROM]: "INSTAGRAM_CTA_CLICKED",
                });
                const eventData = {
                    current_section: gender === "female" ? "Women" : "Men",
                };
                trackV2(ANALYTICS_EVENT_NAMES.OPEN_INSTAGRAM_CTA_CLICKED, eventData);
                // Linking.openURL("https://www.instagram.com/vetirapp/");
            }}
            target={'_blank'} href="https://www.instagram.com/vetirapp/" >
                <Buttons
                textStyle={styles.buttonText}
                containerStyle={styles.button}
                text="Open Instagram"
            />
            </Link>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {},
    headingText: {
        fontFamily: "LibreBodoni",
        textAlign: "left",
        fontSize: fp(32),
        fontWeight: "400",
        color: Colors.black,
        alignSelf: "center",
    },
    navButton: {
        position: "absolute",
        top: "52%",
        borderRadius: 20,
        padding: 10,
    },
    instaCard: {
        width: wp(400),
        height: wp(400),
        transition: "all 0.3s ease", // Note: This won't work in React Native, but keeping for reference
    },
    navButtonLeft: {
        left: 10,
    },
    navButtonRight: {
        right: 10,
    },
    navButtonImage: {
        height: spH(30),
        width: spH(30),
    },
    button: {
        height: spV(36),
        alignSelf: "center",
        width: wp(240),
    },
    buttonText: {
        fontSize: fp(16),
        fontWeight: "350",
    },
});

export default SocialSection;
